module.exports = __webpack_public_path__ + "img/edit.7e535a98.svg";